const TYPES = {
    ICacheStorage: Symbol.for('ICacheStorage'),

    IChannelController: Symbol.for('IChannelController'),

    ICallbackBuilder: Symbol.for('ICallbackBuilder'),

    IFetchHelper: Symbol.for('IFetchHelper'),

    ISettingsStorage: Symbol.for('ISettingsStorage'),

    IRegexSerializer: Symbol.for('IRegexSerializer'),

    IRequestSerializer: Symbol.for('IRequestSerializer'),

    IResponseSerializer: Symbol.for('IResponseSerializer'),
};

export default TYPES;
